wbApp.factory('leadSvc', ['$resource', '$q','repositorySvc',
    function ($resource, $q, repositorySvc) {

        var Lead = $resource('/restapi/leads/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/leads/:id' },
            'getAllByStatusAndDateRange': { method: 'GET', isArray: true, url: 'restapi/leads/info/range/find-by-status' },
            'getAllByStatusAndSemester': { method: 'GET', isArray: true, url: 'restapi/leads/info/find-by-status-and-semester' },
            'getAllByStatusAndStudent': { method: 'GET', isArray: true, url: 'restapi/leads/find-by-status-and-student' },
            'getAllByStatusAndCourse': { method: 'GET', isArray: true, url: 'restapi/leads/info/find-by-status-and-course' },
            'insert': { method: 'POST', url: '/restapi/leads' },
            'update': { method: 'PUT', url: '/restapi/leads/:id' },
            'delete': { method: 'DELETE', url: '/restapi/leads/:id' },
            'admissionAcceptanceNotification': { method: 'POST', url: '/restapi/leads/:id/admission/acceptance-notification' },
            'admissionRejectionNotification': { method: 'POST', url: '/restapi/leads/:id/admission/rejection-notification' },
        });

        function createNew()
        {
            var lead = {
                userId: null,
                studentIds: [],
                semesterId: null,
                leadSourceType: 3,
                leadSourceName: null,
                leadSourceText: null,
                leadSourceReferenceId: null,
                status: 0,
                conversionType: 0,
                notes: [{
                }],
                auditEvents: [],
                marker: null,
                levelId: null,
                phaseId: null,
                isNotRegisteredUser: false,
                isNew: true
            };

            return lead;
        }

        function admissionAcceptanceNotification(id, contractTemplateId, success, error) {
            return repositorySvc.customPostWithParams(
                'admissionAcceptanceNotification',
                Lead,
                { id: id, contractTemplateId: contractTemplateId },
                null,
                success,
                error
            );
        }

        function admissionRejectionNotification(id, contractTemplateId, success, error) {
            return repositorySvc.customPostWithParams(
                'admissionRejectionNotification',
                Lead,
                { id: id, contractTemplateId: contractTemplateId },
                null,
                success,
                error
            );
        }        

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                Lead,
                convertDatesToDateString(model));
        }

        function remove(leadId) {
            return repositorySvc.customDelete(
                'delete',
                Lead,
                { id: leadId });
        }

        function update(model) {
            return repositorySvc.customPutWithParams(
                'update',
                Lead,
                { id: model.id },
                convertDatesToDateString(model));
        }

        function getById(leadId) {
            return repositorySvc.customGet('getById', Lead, { id: leadId });
        }


        function getAllByStatusAndDateRange(status, fromDateUtc, toDateUtc) {
            return repositorySvc.customGet('getAllByStatusAndDateRange', Lead, {
                status: status,
                fromDateUtc: fromDateUtc,
                toDateUtc: moment(toDateUtc).endOf('day').toDate(),
                expanded: 'PersonalInformation'
            });
        }

        function getAllByStatusAndSemester(status, semesterId) {
            return repositorySvc.customGet('getAllByStatusAndSemester', Lead, {
                status: status,
                semesterId: semesterId,
                expanded: 'PersonalInformation'
            });
        }

        function getAllByStatusAndStudent(status, studentId) {
            return repositorySvc.customGet('getAllByStatusAndStudent', Lead, {
                status: status,
                studentId: studentId
            });
        }

        function getAllByStatusAndCourse(status, courseId) {
            return repositorySvc.customGet('getAllByStatusAndCourse', Lead, {
                status: status,
                courseId: courseId,
                expanded: 'PersonalInformation'
            });
        }

        function markerIdToColor(markerId) {
            switch (markerId) {
                case 0: return "#f23430"; // red
                case 1: return "#f38b24"; // orange
                case 2: return "#f4c12c"; // yellow
                case 3: return "#2cc141"; // green
                case 4: return "#1374f1"; // blue
                case 5: return "#9e50c6"; // purple
                case 6: return "#848489"; // gray
                default: return 'white';
            }
        }

        return {
            createNew: createNew,
            getById: getById,
            getAllByStatusAndDateRange: getAllByStatusAndDateRange,
            getAllByStatusAndSemester: getAllByStatusAndSemester,
            getAllByStatusAndStudent: getAllByStatusAndStudent,
            getAllByStatusAndCourse: getAllByStatusAndCourse,
            insert: insert,
            remove: remove,
            update: update,
            markerIdToColor: markerIdToColor,
            admissionAcceptanceNotification: admissionAcceptanceNotification,
            admissionRejectionNotification: admissionRejectionNotification
        }
    }
]);